import React, { useState, useEffect } from 'react';
import { Outlet } from "react-router-dom"
import Preloader from '../composants/site/Preloader';

const Sitelayout = () => {
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        // On affiche le preloader seulement au premier chargement du site dans la session
        const hasLoaded = sessionStorage.getItem('site_loaded');
        if (!hasLoaded) {
            setLoading(true);
            const timer = setTimeout(() => {
                setLoading(false);
                sessionStorage.setItem('site_loaded', 'true');
            }, 6000);
            return () => clearTimeout(timer);
        }
    }, []);

    if (loading) return <Preloader />;

    return (
        <div>
            <Outlet />
        </div>
    );
};

export default Sitelayout;